import { StreetviewData, ToTheDoorData } from "../types";

export interface AddressMessage {
  type: "addressMessage";
  geoPoint: google.maps.LatLngLiteral | null;
  streetviewData: StreetviewData | null;
  toTheDoorData: ToTheDoorData | null;
  roadNames: string[];
}

/* interface PlaceSuggestionsMessage {
  type: "placeSuggestions";
  placeSuggestions: PlaceSuggestion[];
} */

interface ErrorMessage {
  type: "error";
  message?: string;
}

interface DeviceIdMessage {
  type: "deviceId";
  deviceId?: string;
}

type Payload = AddressMessage | ErrorMessage | DeviceIdMessage;

interface OkHiPortalToInlineMessage {
  source: "okhi";
  isPortalOpen: boolean;
  payload?: Payload;
}

export function useOkHiMessageSender() {
  const sendMessage = (
    payload: Payload,
    { closePortal = true }: { closePortal?: boolean } = {}
  ) => {
    const message: OkHiPortalToInlineMessage = {
      source: "okhi",
      isPortalOpen: !closePortal,
      payload,
    };
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const closePortal = () => {
    const message: OkHiPortalToInlineMessage = {
      source: "okhi",
      isPortalOpen: false,
    };
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const openPortal = () => {
    const message: OkHiPortalToInlineMessage = {
      source: "okhi",
      isPortalOpen: true,
    };
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  return { sendMessage, closePortal, openPortal };
}
